import { classNames } from "helpers";
import { useCallback } from "react";
import { SwitchProps } from "./types";
import React from "react";


const Switch: React.FC<SwitchProps> = ({
  name,
  checked = false,
  onChange,
  disabled,
  labelLeft,
  labelRight,
}) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (disabled) return;
      onChange?.(e);
    },
    [onChange, disabled]
  );

  return (
    <label
      className={classNames(
        "flex items-center space-x-2 select-none",
        disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"
      )}
    >
      {labelLeft && (
        <span
          className={classNames(
            "text-sm font-medium",
            disabled ? "text-gray-400" : "text-gray-700"
          )}
        >
          {labelLeft}
        </span>
      )}

      <div className="relative">
        {/* Hidden checkbox */}
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className="sr-only peer"
        />

        {/* Track */}
        <div
          className={classNames(
            "w-11 h-6 rounded-full transition-colors duration-300",
            disabled
              ? "bg-gray-300"
              : "bg-gray-300 peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-300"
          )}
        ></div>

        {/* Thumb */}
        <div
          className={classNames(
            "absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300",
            "peer-checked:translate-x-5"
          )}
        ></div>
      </div>

      {labelRight && (
        <span
          className={classNames(
            "text-sm font-medium",
            disabled ? "text-gray-400" : "text-gray-700"
          )}
        >
          {labelRight}
        </span>
      )}
    </label>
  );
};

export default React.memo(Switch);